import { useWindowSize } from '@vueuse/core';
import {
  currentPlatform,
  isBlocked,
  type PlatformFlags,
  type RequestPlatform,
} from '~/utils/apostatudo/platform-gate';

/**
 * A plataforma atual, reativa (ENG-824).
 *
 * Existe para NÃO chamar `useLayout()` fora de um componente. Aquele composable registra
 * um `watch` na largura que ABRE E FECHA O MENU LATERAL — um efeito colateral que nasce
 * com quem o chamou e morre junto. Numa store Pinia ele não morre nunca: sobrevive a toda
 * navegação e passa a disparar `openMenu`/`closeMenu` uma vez a mais por travessia de
 * breakpoint, sem que ninguém na tela tenha pedido isso.
 *
 * Aqui só se lê a largura. O breakpoint é o MESMO 1024 do `isDesktop` do `useLayout`, de
 * propósito: o header da requisição tem de carregar o mesmo critério que pintou a tela,
 * senão o core discorda da parede que o jogador está vendo.
 */
const DESKTOP_MIN_WIDTH = 1024;

export const usePlatformGate = () => {
  // `initialWidth: 0` e não o default `+Infinity`: antes do primeiro `resize` o padrão
  // responderia `web_desktop` enquanto o `isDesktopViewport()` do header cai em `false`
  // (`web_mobile`) — os dois arquivos prometem carregar o mesmo critério, e nesse instante
  // discordavam. Hoje não dispara porque nada chama o core no servidor, mas é a armadilha
  // que espera quem for tornar estes adapters SSR-safe.
  const { width } = useWindowSize({ initialWidth: 0 });

  const platform = computed<RequestPlatform>(() =>
    currentPlatform(width.value >= DESKTOP_MIN_WIDTH),
  );

  /** Atalho para o par (flags, plataforma de agora) — a leitura que toda store faz. */
  function isBlockedHere(flags: PlatformFlags | null | undefined): boolean {
    return isBlocked(flags, platform.value);
  }

  return { platform, isBlockedHere };
};
